module.exports = __webpack_public_path__ + "img/uti_logo_white.77abc5c7.svg";